import { ROLE_TYPE_PROVIDER } from "../../../constants/RegisterConstants";
import ResidentEntryLogPageContent from "../components/ResidentEntryLogPageContent";

const ProviderResidentEntryTrackerPage = () => (
  <ResidentEntryLogPageContent
    expectedRole={ROLE_TYPE_PROVIDER}
    entryType="resident_movement"
    pageTitle="Entry Tracker"
    pageSubtitle="Review resident In and Out entries, add corrections, and keep the daily record organized."
    sectionTitle="Entry Tracker"
    sectionDescription=""
    defaultComposerVisible
    showComposerToggleButton
    compactActionBar
    allowDrafts={false}
    enableMonthlyReport
    monthlyReportTitle="Generate Report"
    monthlyReportDescription="Review resident In and Out entries and export a report for follow-up and recordkeeping."
    loadMonthlyReport={(store, residentId, options) => store.getResidentMovementMonthlyDataset(residentId, options)}
    generateMonthlyReportDocument={(store, residentId, requestBody) => store.generateResidentMovementReportDocument(residentId, requestBody)}
    loadEntriesPage={(store, residentId, options) => store.getResidentMovementEntriesPage(residentId, options)}
    createEntry={(store, residentId, payload) => store.createResidentMovementEntry(residentId, payload)}
    updateEntry={(store, residentId, payload) => store.updateResidentMovementEntry(residentId, payload)}
    deleteDraft={(store, residentId, entryLogId) => store.deleteResidentMovementEntry(residentId, entryLogId)}
    canEditEntry={() => true}
    readOnlyArchivedResident
  />
);

export default ProviderResidentEntryTrackerPage;
